import type { FeedEngine } from './feed-engine';

// Tracks whether an anonymous visitor arrived in the reader by following a feed from a public
// Share / Subscribe link (rather than discovering Downread on its own). The Home page uses this to
// swap the generic pitch for a feed-first welcome that explains the basics and the limits of anon mode.
const ANON_FROM_SHARE_KEY = 'anon-from-share';

// When a brand-new visitor follows their very first feed from a share link, configure it with sensible
// defaults (track unread, newest first) instead of leaving the sort order unset. An unset order ('A')
// is what triggers the "How do you want to read this feed?" setup card in the reader — overwhelming for
// someone who just wanted to read. Returning users keep getting the card for feeds they add later.
export const applyFirstFeedDefaults = (feedEngine: FeedEngine, feedId: string) => {
  if (feedEngine.getFeeds().length > 1) return;
  feedEngine.setShowRead(feedId, 'u');
  feedEngine.setSortOrder(feedId, 'N');
};

export const markAnonFromShare = () => {
  try { localStorage.setItem(ANON_FROM_SHARE_KEY, '1'); } catch { /* storage unavailable */ }
};

export const cameFromShare = (): boolean => {
  try { return localStorage.getItem(ANON_FROM_SHARE_KEY) == '1'; } catch { return false; }
};
